import React, { useEffect, useState } from "react";
import {
  DgaCircleSkeleton,
  DgaLineSkeleton,
  DgaRectangleSkeleton,
} from "platformscode-new-react";

import { DgaIcon } from "platformscode-new-react";
import CountUp from "react-countup";
import { getHomeAboutUs } from '../../../services/api';
import AOS from "aos";
import "aos/dist/aos.css";
const secondaryPattern = "assets2/imges/Secondary Pattern 1.svg";
const aboutUsIcon = "assets2/imges/AboutUsPattern.svg";

function AboutUsSection() {
  const [statistics, setStatistics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStatistics = async () => {
      try {
        const data = await getHomeAboutUs();
        setStatistics(data.data);
      } catch (err) {
        console.error("خطأ في تحميل البيانات:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchStatistics();
  }, []);

  if (loading) {
    return (
      <section className="cw-full" id="aboutus">
        <h1 data-aos="fade-in" className="display-sm-bold text-[#161616] mb-4">
          <DgaRectangleSkeleton size="md" type="1" width="long" />
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 top-cards gap-4">
          {[0, 300, 600, 900].map((index) => (
            <div
              key={index}
              className="flex flex-col justify-center items-center item-data"
            >
              <DgaCircleSkeleton
                style={{ marginBottom: "24px" }}
                type="1"
                width="56px"
              />
              <h3 className="h-full display-md-regular text-[#14573A] mt-[24px]">
                <DgaRectangleSkeleton size="md" type="1" width="short" />
              </h3>
              <p className="h-full text-md-regular text-[#1d2228] mt-[8px] text-center">
                <DgaLineSkeleton
                  type="1"
                  size="sm"
                  className="w-[100px] mt-[12px] flex"
                  style={{ marginTop: "12px" }}
                />
              </p>
            </div>
          ))}
        </div>
      </section>
    );
  }

  if (error && statistics.length === 0) {
    return (
      <section id="aboutus">
        <div className="flex justify-center items-center h-64">
          <p className="text-xl text-red-500">
            حدث خطأ أثناء تحميل البيانات. يرجى المحاولة مرة أخرى لاحقًا.
          </p>
        </div>
      </section>
    );
  }

  return (
    <>
      <section className="cw-full" id="aboutus">

        <div data-aos="fade-in" className="flex items-center gap-[20px] mb-4">
          <h1 className="display-sm-bold text-[#161616]">
            أرقام وإنجازات الأمانة لعام 2026
          </h1>
        </div>

        <div
          data-aos="fade-left"
          className="grid grid-cols-2 sm:grid-cols-2  md:grid-cols-4 gap-[32px] mt-[32px]"
        >
          {statistics.map((element, index) => (
            <div
              key={element.id}
              data-aos="zoom-in"
              data-aos-delay={index * 200} // 👈 التأخير التدريجي
              className="flex flex-col justify-center items-center item-data"
            >
              <div className="img">
                <DgaIcon
                  color="#067647"
                  icon={element.icon}
                  size={28}
                  type="rounded"
                  variant="stroke"
                />
              </div>
              <p aria-hidden="true">
                <span className="display-md-bold text-[#14573A] mt-[24px]">
                  <CountUp
                    start={0}
                    end={element.number}
                    duration={3}
                    separator=","
                  />
                </span>
              </p>
              <p className="text-md-regular text-[#1d2228] mt-[8px] text-center" >
                {element.title}
              </p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}

export default AboutUsSection;
